<template>
  <div class="footer">
    <div class="footer-info">
      <div>版权所有©清远市嘉兴医药有限公司</div>
      <div></div>
    </div>
    <img src="../../static/images/service.png" class="footer-img" alt="二维码图片">
  </div>
</template>
<script>
export default {

}
</script>
<style scoped>
  .footer{
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 0;
    height: 140px;
    background-color: #e2e5e5;
    font-size: 12px;
  }
  .footer-info{
    display: inline-block;
    margin-top: 65px;
  }
  .footer-img{
    position: relative;
    bottom: 26px;
    left: 250px;

  }
</style>
